import PageHeader from "@/components/PageHeader";
import ListSection from "@/components/ListSection";

const LEVELS = ["Grundläggande", "Van", "Erfaren", "Expert"];

const FIELDS = [
  { name: "name", label: "System / program", type: "text", placeholder: "T.ex. Excel, SAP, Fortnox" },
  { name: "level", label: "Erfarenhetsnivå", type: "select", options: LEVELS },
  { name: "usage", label: "Hur systemet har använts", type: "textarea", full: true, placeholder: "I vilket sammanhang och till vad?" },
];

export default function SystemVerktyg() {
  return (
    <div>
      <PageHeader
        title="System och verktyg"
        description="Lägg till system och program du använt – t.ex. Excel, Word, Outlook, Teams, SAP, ERP, CRM, kassasystem, bokningssystem eller CAD."
      />
      <ListSection
        endpoint="systems"
        fields={FIELDS}
        addLabel="Lägg till system"
        emptyText="Inga system tillagda ännu."
        summary={(it) => ({ title: it.name, subtitle: it.level, body: it.usage })}
      />
    </div>
  );
}
